import IdleTracker from 'idle-tracker';

// Initialize idle tracking when both heap and IdleTracker are available
const idleTime = 30000 // 30 seconds in milliseconds
const trackIdle = function(payload) {
  if (payload.idle) {
    if (window.heap) { //this is here for testing the idle timer in environments where there is no heap
      window.heap.track('user_idle', { idleTime: idleTime });
    } else {
      console.log('user idle - heap is not available')
    }
  }
}

const idleTracker = new IdleTracker({
  timeout: idleTime, 
  onIdleCallback: trackIdle
});

document.addEventListener('DOMContentLoaded', function() {
  idleTracker.start();
}, { once: true });

// Track when the user closes the page
document.addEventListener('beforeunload', function() {
  if (window.heap) {
    window.heap.track('user_close_page')
  }
})